/**
 * STOMP endpoint, derived from wherever the admin panel is actually being served
 * (NMU-430).
 *
 * It used to be hardcoded to "wss://www.nmu.ac.th/..." — the production host —
 * so opening the panel on dev or uat had the browser dial production. Building it
 * from window.location keeps one value correct in every environment, and routing
 * it through REACT_APP_API_ENDPOINT reuses the same nginx rewrite the REST calls
 * use (/api/wsk -> /nmu-admin-service/wsk).
 */
const adminWebsocketUrl = () => {
  if (typeof window === "undefined") return "";

  const base = process.env.REACT_APP_API_ENDPOINT || "";

  // An absolute base (some deployments point straight at the service) already
  // carries its own host, so only swap the scheme.
  if (/^https?:\/\//i.test(base)) {
    return `${base.replace(/^http/i, "ws").replace(/\/+$/, "")}/wsk`;
  }

  const scheme = window.location.protocol === "https:" ? "wss" : "ws";
  return `${scheme}://${window.location.host}${base.replace(/\/+$/, "")}/wsk`;
};

export const APP_CUSTOM_API = {
  ADMIN_SERVICE: "/nmu-management-service",
  ADMIN_WSK: adminWebsocketUrl(),
};

// NOTE: file/image URLs are built in utils/file-utils.js from
// REACT_APP_API_ENDPOINT (dev: "/api" -> nmu-management-service), which serves
// /render/attach, /render/gallery, /render/temp, /render/download and
// /render/embed. The retired nmu-display-service is no longer referenced.

// Phase 3 REST endpoints (centralized).
//
// ⚠️ These MUST carry the REACT_APP_API_ENDPOINT prefix like every other api/
// module does (NMU-417). The admin nginx rewrites `^/api/(.*)$` to
// `/nmu-admin-service/$1`, i.e. it consumes one path segment. A bare
// "/api/v1/admin/programs" therefore arrives as "/nmu-admin-service/v1/admin/programs"
// — a path that has no handler and is not in the security permitAll list, so
// Spring answers **401 before reaching a controller**. It looks exactly like an
// expired session, which is what it was mistaken for.
//
// Prefixing here rather than in each api/ module means a new endpoint added to
// this map cannot reintroduce the bug.
const ADMIN_API_BASE = process.env.REACT_APP_API_ENDPOINT || "";

export const API_PATH = {
  // Feature config admin API (GET list, PUT update).
  FEATURE_CONFIG: `${ADMIN_API_BASE}/api/v1/admin/feature-config`,
  ANALYTICS: `${ADMIN_API_BASE}/api/v1/admin/analytics`,
  // Programs (หลักสูตร) admin API: GET list/getById, POST create, PUT update, DELETE remove.
  PROGRAM: `${ADMIN_API_BASE}/api/v1/admin/programs`,
  // NMU-473: homepage slider cards.
  SLIDER: `${ADMIN_API_BASE}/api/v1/admin/sliders`,
  // NMU-478: staff-intranet portal cards.
  INTRANET: `${ADMIN_API_BASE}/api/v1/admin/intranet`,
  // NMU-608: ทางลัดด่วน — the portal shortcut row.
  QUICK_LINK: `${ADMIN_API_BASE}/api/v1/admin/quick-links`,
  // Footer Layer C settings (NMU-421): GET the one document, PUT to save it.
  FOOTER_SETTINGS: `${ADMIN_API_BASE}/api/v1/admin/footer-settings`,
};
